<div class="min-vh-100 d-flex flex-column">
  <Navbar class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0" />

  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">
      <main class="col h-100 overflow-auto">
        <div class="marketplace-toolbar-center text-center flex-grow-1 mb-4">
          <h4 class="text-dark mb-1 fw-bold marketplace-toolbar-title">Ads Centre</h4>
        </div>

        <div class="d-flex align-items-center gap-2 flex-wrap mb-3">
          <button
            type="button"
            class="btn btn-sm btn-primary rounded text-xxs cursor-pointer position-relative"
            @click="open_create_advertisement_modal"
          >
            <span>Create</span>
          </button>
          <div class="position-relative w-100 w-sm-auto max-width-230">
            <i
              class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
            ></i>
            <input
              v-model="search_query"
              type="text"
              class="form-control rounded-pill ps-5 text-xxs"
              placeholder="Search Ads..."
            />
          </div>
        </div>

        <div
          v-if="is_loading_advertisements"
          class="d-flex flex-column align-items-center justify-content-center text-center w-100 py-5 min-height-50vh"
        >
          <div class="spinner-border text-primary mb-3" role="status">
            <span class="visually-hidden">Loading advertisements...</span>
          </div>
          <p class="text-muted text-xxs mb-0">Loading advertisements...</p>
        </div>

        <div v-else class="row g-3 marketplace-products-grid mb-5 pb-extra">
          <div
            v-for="advertisement in filtered_advertisements"
            :key="advertisement.id"
            class="col-12 col-md-4 col-xl-3">
            <div class="marketplace-product-card marketplace-product-card-compact h-100 d-flex flex-column">
              <div class="position-relative marketplace-card-media">
                <div
                  v-if="advertisement?.files?.length"
                  :id="`ads-card-carousel-${advertisement.id}`"
                  class="carousel slide"
                  data-bs-ride="false"
                >
                  <div
                    v-if="advertisement?.files?.length > 1"
                    class="carousel-indicators">
                    <button
                      v-for="(media_item, media_index) in advertisement?.files"
                      :key="`indicator-${advertisement.id}-${media_item.id}`"
                      type="button"
                      :data-bs-target="`#ads-card-carousel-${advertisement.id}`"
                      :data-bs-slide-to="media_index"
                      :class="{ active: media_index === 0 }"
                      :aria-current="media_index === 0 ? 'true' : undefined"
                      :aria-label="`Slide ${media_index + 1}`"
                    ></button>
                  </div>

                  <div class="carousel-inner">
                    <div
                      v-for="(media_item, media_index) in advertisement?.files"
                      :key="`media-${advertisement.id}-${media_item.id || media_index}`"
                      class="carousel-item"
                      :class=
                      "{ active: media_index === 0 }"
                    >
                      <div class="ad-media-box overflow-hidden rounded-4">
                        <img
                          v-if="getMediaType(media_item) === 'image'"
                          :src="get_file_url(media_item)"
                          :alt="get_file_name(media_item)"
                          class="marketplace-card-image"
                        />

                        <div v-else class="position-relative w-100 h-80 overflow-hidden rounded-4">
                          <video
                            :src="get_file_url(media_item)"
                            class="ad-card-video"
                            autoplay
                            muted
                            loop
                            preload="auto"
                            playsinline
                          >
                            Your browser does not support the video tag.
                          </video>
                          <i
                            class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white"
                          ></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    v-if="advertisement?.files?.length > 1"
                    class="carousel-control-prev"
                    type="button"
                    :data-bs-target="`#ads-card-carousel-${advertisement.id}`"
                    data-bs-slide="prev"
                  >
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>

                  <button
                    v-if="advertisement?.files?.length > 1"
                    class="carousel-control-next"
                    type="button"
                    :data-bs-target="`#ads-card-carousel-${advertisement.id}`"
                    data-bs-slide="next"
                  >
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div> 


                <div class="position-absolute top-0 end-0 m-2">
                  <div class="d-flex gap-2">
                    <span
                      class="badge"
                      :class="advertisement?.is_active ? 'task-chip task-chip-status' : 'task-due-chip d-inline-flex align-items-center fw-500 task-due-chip-overdue'"
                    >
                      {{ advertisement?.is_active? "Published": "UnPublished" }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
                <div class="flex-grow-1 ">
                  <p class="marketplace-card-name mb-1">
                    {{ advertisement?.title }}
                  </p>
                  <div class="text-xxs text-muted mb-0 ads-center-card-description">
                    {{ get_description_preview(advertisement?.description, advertisement?.id) || '\u00A0' }}
                  </div>
                 <div class="d-flex justify-content-between align-items-end gap-2 mt-3 marketplace-card-footer ads-center-card-cta-row">
                    <a
                      v-if="advertisement?.redirect_url"
                      :href="advertisement?.redirect_url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="btn btn-sm btn btn-primary rounded text-xxs py-2 px-4 ms-auto ads-center-card-cta"
                    >
                      {{ get_cta_label(advertisement) }}
                    </a>
                  </div>
                </div>

                <div class="d-flex flex-wrap gap-1 mt-2 ads-center-card-actions">
                  <button type="button" class="btn btn-primary rounded text-xxs py-1 px-2 flex-fill"  @click.stop="toggle_advertisement_is_active(advertisement)">
                    {{ advertisement?.is_active ? 'Unpublish' : 'Publish' }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary rounded text-xxs py-1 px-2 flex-fill"
                    @click.stop="open_manage_advertisement_modal(advertisement)"
                  >
                    Manage
                  </button>
              </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</div>

<teleport to="body">
  <div
    class="modal fade"
    id="create_advertisement_modal"
    tabindex="-1"
    aria-labelledby="createAdvertisementModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
      <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
        <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
          <button
            type="button"
            class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="fas fa-times fs-6"></i>
          </button>
        </div>

        <form @submit.prevent="save_advertisement">
          <div class="modal-body px-4 pt-0 pb-3 modal-body-scroll">
            <div class="mb-3">
              <h5 class="mb-1">{{ is_editing_advertisement ? 'Edit Advertisement' : 'Create Advertisement' }}</h5>
              <p class="text-muted text-xxs mb-0">
                {{ is_editing_advertisement ? 'Update the advertisement details below.' : 'Add a new advertisement with media and a redirect URL.' }}
              </p>
            </div>

             <div class="mb-3">
              <label class="form-label text-xxs fw-500">Title</label>
              <input
                v-model="title"
                class="form-control rounded text-xxs"
                placeholder="What this advertisement promotes..."
              ></input>
            </div>

            <div class="mb-3">
              <label class="form-label text-xxs fw-500">Description</label>
              <textarea
                v-model="description"
                class="form-control rounded text-xxs"
                placeholder="Describe what this advertisement promotes..."
              ></textarea>
            </div>

            <div class="row g-3 mb-3">
              <div class="col-md-6">
                <label class="form-label text-xxs fw-500">Redirect URL</label>
                <input
                  v-model="redirection_url"
                  type="text"
                  class="form-control rounded text-xxs"
                  placeholder="https://example.com/landing"
                />
              </div>

              <div class="col-md-6">
                <label class="form-label text-xxs fw-500">Status</label>
                <div
                  class="d-flex align-items-center justify-content-between rounded border bg-white px-3 text-xxs workflow-step-icon-wrapper"
                >
                  <span class="text-xxs fw-500 text-dark">
                    {{ is_active ? 'Active' : 'Deactivated' }}
                  </span>
                  <div class="form-check form-switch d-flex align-items-center m-0">
                    <input
                      v-model="is_active"
                      class="form-check-input ms-0"
                      type="checkbox"
                      role="switch"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div v-if="media_previews?.length" class="d-flex flex-wrap gap-3 mt-3 px-1 mb-3">
              <div
                v-for="(preview, index) in media_previews"
                :key="`${preview.name}-${index}`"
                class="position-relative mb-2 profile-avatar"
              >
                <img
                  v-if="getMediaType(preview) === 'image'"
                  :src="get_file_url(preview)"
                  class="rounded-3 border w-100 h-100 cart-item-img"
                />

                <div v-else-if="getMediaType(preview) === 'video'" class="position-relative w-100 h-100">
                  <video class="rounded-3 border w-100 h-100 cart-item-img">
                    <source :src="get_file_url(preview)" />
                  </video>
                  <i class="bi bi-play-circle-fill position-absolute top-50 start-50 translate-middle text-white fs-3 opacity-75"></i>
                </div>

                <div
                  v-else
                  class="rounded-3 border bg-light d-flex flex-column align-items-center justify-content-center text-center p-2 w-100 h-100"
                >
                  <i class="bi bi-file-earmark-text-fill text-secondary fs-2"></i>
                  <span class="text-xxs text-truncate w-100 px-1">{{ get_file_name(preview) }}</span>
                </div>

                <button
                  type="button"
                  class="btn btn-sm btn-danger fw-bold position-absolute top-0 end-0 fs-6 px-2 py-0"
                  @click.stop="remove_media_preview(index)"
                >
                  &times;
                </button>
              </div>
            </div>

            <div
              class="d-flex align-items-center justify-content-center pointer border-2 rounded p-3 mb-3 text-center position-relative border border fw-bold"
              role="button"
              tabindex="0"
              @click="open_media_picker"
              @keydown.enter.prevent="open_media_picker"
              @keydown.space.prevent="open_media_picker"
            >
              <input
                ref="ads_media_input"
                type="file"
                class="d-none"
                multiple
                accept="image/*,video/*"
                @change="handle_media_upload"
              />
              <div class="d-flex flex-column align-items-center justify-content-center gap-1">
                <i class="bi bi-cloud-plus-fill text-primary fs-4"></i>
                <span class="fw-bold text-black text-sm">Upload images or videos</span>
              </div>
            </div>
          </div>

          <div class="modal-footer border-0 px-4 pb-4 pt-0 gap-3">
            <button
              type="submit"
              class="btn btn-sm btn-primary rounded text-xxs cursor-pointer position-relative"
              :disabled="!can_save_advertisement"
            >
              {{ is_editing_advertisement ? 'Save Changes' : 'Save' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="manage_advertisement_modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header border-0 shadow-sm">
          <h5 class="modal-title text-xs">
            Manage Advertisement
          </h5>
          <button
            type="button"
            class="btn-close btn-close-black text-xs"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close_manage_advertisement_modal"
          ></button>
        </div>

        <div class="modal-body manage-product-modal-body modal-body-scroll">
          <div class="row g-4" v-if="modal_advertisement">
            <div class="col-12 col-lg-5">
              <div class="border rounded-4 p-3 bg-light-subtle h-100">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <label class="form-label fw-bold mb-0">Images</label>
                  <span class="badge bg-dark-subtle text-dark">
                    {{ modal_advertisement?.files?.length }} media
                  </span>
                </div>

                <div v-if="modal_advertisement?.files?.length" class="position-relative">
                  <div class="ratio ratio-1x1-product bg-light rounded overflow-hidden">
                    <img
                      v-if="getMediaType(active_manage_media) === 'image'"
                      :src="get_file_url(active_manage_media)"
                      class="w-100 h-100 object-fit-cover"
                    />
                    <video
                      v-else
                      class="w-100 h-100 object-fit-cover"
                      controls
                    >
                      <source :src="get_file_url(active_manage_media)" />
                    </video>
                  </div>

                  <button
                    v-if="modal_advertisement?.files?.length > 1"
                    class="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2 rounded-circle shadow-sm"
                    @click="prev_manage_media"
                  >
                    <i class="bi bi-chevron-left"></i>
                  </button>

                  <button
                    v-if="modal_advertisement?.files?.length > 1"
                    class="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2 rounded-circle shadow-sm"
                    @click="next_manage_media"
                  >
                    <i class="bi bi-chevron-right"></i>
                  </button>

                  <div class="d-flex gap-2 mt-2 overflow-auto w-100">
                    <div v-for="(media_item, idx) in modal_advertisement.files" :key="`manage-media-${idx}`">
                      <img
                        v-if="getMediaType(media_item) === 'image'"
                        :src="get_file_url(media_item)"
                        class="border rounded flex-shrink-0 cursor-pointer cart-item-img image-preview-box"
                        @click="set_active_manage_media(idx)"
                      />
                      <video
                        v-else
                        :src="get_file_url(media_item)"
                        class="border rounded d-flex align-items-center justify-content-center bg-dark text-white flex-shrink-0 cursor-pointer image-preview-box"
                        @click="set_active_manage_media(idx)"
                      >
                        <i class="bi bi-play-fill"></i>
                    </video>
                    </div>
                  </div>
                </div>

                <div
                  v-else
                  class="preview-image-wrapper border rounded overflow-hidden d-flex align-items-center justify-content-center"
                >
                  <img :src="require('@/assets/images/image_placeholder.jpg')" class="preview-image">
                </div>
              </div>
            </div>

            <div class="col-12 col-lg-7">
              <div class="border rounded-4 p-3 h-100">
                <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                  <div>
                    <h6 class="fw-bold mb-1">Advertisement details</h6>
                    <p class="text-muted small mb-0">
                      Review the advertisement information below.
                    </p>
                  </div>
                  <span class="badge bg-secondary-subtle text-secondary">
                    Viewing
                  </span>
                </div>

                <div class="text-start">
                  <div class="mb-3">
                    <label class="form-label fw-bold">Title</label>
                    <span class="d-block">{{ modal_advertisement?.title || 'Untitled advertisement' }}</span>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bold">Status</label>
                    <span class="d-block">{{ modal_advertisement?.is_active ? "Active": "Deactivated"}}</span>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bold">Redirect URL</label>
                    <span class="d-block text-muted">
                      {{ modal_advertisement?.redirect_url || modal_advertisement?.redirection_url }}
                    </span>
                  </div>

                  <div class="mb-3">
                    <label class="form-label fw-bold">Description</label>
                    <span class="d-block text-muted">
                      {{ modal_advertisement?.description}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer manage-product-modal-footer d-flex gap-2 border-top bg-white">
          <div class="d-flex gap-2 w-100">
            <button
              class="btn btn-primary btn-sm rounded flex-fill"
              @click="edit_advertisement(modal_advertisement)"
            >
              Edit
            </button>

            <button
              class="btn btn-primary rounded btn-sm flex-fill"
              @click="confirm_delete_advertisement(modal_advertisement)"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
